import { render, staticRenderFns } from "./followRecords.vue?vue&type=template&id=4bb2fd88&"
import script from "./followRecords.vue?vue&type=script&lang=js&"
export * from "./followRecords.vue?vue&type=script&lang=js&"
import style0 from "./followRecords.vue?vue&type=style&index=0&id=4bb2fd88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports